<template>
    <div class="flex items-center">
        <div v-for="(profile, index) in profilesToShow"  class="bg-white p-[1px] rounded-full" :class="{ '-ml-2': index !== 0 }">
            <Avatar class="w-5 h-5" />
        </div>
        <div v-if="profiles.length > profilesToShow.length" class="-ml-2 bg-white p-[1px] rounded-full">
            <div class="text-xs bg-gray-200 text-gray-700 rounded-full w-5 h-5 flex items-center justify-center">
                {{profiles.length - profilesToShow.length}}
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import Avatar from "~/components/ui/Avatar.vue";

    const { profiles } = defineProps<{
        profiles: [any]
    }>()

    const profilesToShow = computed(() => profiles.slice(0, 3))
</script>
